module.exports = __webpack_public_path__ + "img/bianYaQi5.990fb972.png";